export default __webpack_public_path__ + "img/akitabox_logo.png";